var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSidemenuToggle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.874,
    height: 11.747,
    viewBox: "0 0 14.874 11.747",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_sidemenu_toggle",
    transform: "translate(-215.356 -114.126)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48838",
    "data-name": "Path 48838",
    d: "M12,12l4.46,4.46L12,20.919",
    transform: "translate(212.771 103.541)",
    fill: "none",
    stroke: "#16173b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48839",
    "data-name": "Path 48839",
    d: "M12,12l4.46,4.46L12,20.919",
    transform: "translate(204.771 103.541)",
    fill: "none",
    stroke: "#16173b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSidemenuToggle);
export default __webpack_public_path__ + "static/media/ic_sidemenu_toggle.70220da87b8b946c0282117eb24858c8.svg";
export { ForwardRef as ReactComponent };